import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../app/appTypes";
import { postWithAuth } from "../../http";


export interface AiDocumentMetaRequestDto {
    htmlPage: string;
}

export interface AiCompanyMatchResultDto {
    publicId: string;
    displayName: string;
    countryCode: string;
    score: number;
}

export interface AiDocumentMetaAnswerDto {
    title: string | null;
    number: string | null;
    version: number | null;
    issuerCompanyName: string | null;
    structureId: number | null;
    author: string | null;
    companyMatchResult?: AiCompanyMatchResultDto[];
}


export const extractAiDocumentMeta = createAsyncThunk<
    AiDocumentMetaAnswerDto,
    AiDocumentMetaRequestDto,
    AppThunkAPIType
>(
    "ai/documentMeta/extract",
    async (req, { dispatch, rejectWithValue }) => {
        const result = await dispatch(postWithAuth({
            url: "api/ai/document-meta/extract",
            payload: req,
        }));

        const { payload } = result;

        if (postWithAuth.fulfilled.match(result)) {
            return payload as AiDocumentMetaAnswerDto;
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);
